export default __webpack_public_path__ + "static/media/zeus.9bcbb401.png";